import Carousel from "components/Carousel";
import { DataBanner } from "./data-banner";

export default function Banner() {

    return <Carousel bannerList={DataBanner} />;
}
